/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { ROOT_SLICE } from '../constants';
import { toTimeuuids, forceArray } from '../util';

const { 
	// SYNCING
	addIsSyncing, 
	removeIsSyncing, 
	clearIsSyncing,
	
	addIsUnsyncing, 
	removeIsUnsyncing, 
	clearIsUnsyncing,

	// DELETING
	addIsDeleting, 
	removeIsDeleting, 
	clearIsDeleting,

	addIsDeleted,
	removeIsDeleted,
	clearIsDeleted,
	
	addIsQueuedForDelete, 
	removeIsQueuedForDelete, 
	clearIsQueuedForDelete,
	
	// SELECTED SURVEYS
	addIsSelected, 
	removeIsSelected, 
	clearIsSelected,

	// AUTO FIX PM/CTS
	setAutoFixStore,
	addAutoFixPmCt,
	removeAutoFixPmCt, 
	clearAutoFixPmCt,
	setAutoFixIsFixing,
	setAutoFixIsStopping,

	// CACHED JOBS - Component JobList Local State Cache - CISV JobList component manages state locally, this allows us to cache that local state in redux and make it available to our selectors.
	setJobListTab,
	setFJobs, // (filter gui tab, initial gui tab)
	setSJobs, // (search gui tab, second gui tab)

	// ERROR MESSAGES
	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	
	clear,
 } = createActions(
	{
		ADD_IS_SYNCING: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		REMOVE_IS_SYNCING: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		CLEAR_IS_SYNCING: () => ({}),



		ADD_IS_UNSYNCING: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		REMOVE_IS_UNSYNCING: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		CLEAR_IS_UNSYNCING: () => ({}),



		ADD_IS_DELETING: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		REMOVE_IS_DELETING: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		CLEAR_IS_DELETING: () => ({}),



		ADD_IS_DELETED: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		REMOVE_IS_DELETED: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		CLEAR_IS_DELETED: () => ({}),



		ADD_IS_QUEUED_FOR_DELETE: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		REMOVE_IS_QUEUED_FOR_DELETE: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		CLEAR_IS_QUEUED_FOR_DELETE: () => ({}),



		ADD_IS_SELECTED: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		REMOVE_IS_SELECTED: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		CLEAR_IS_SELECTED: () => ({}),



		SET_AUTO_FIX_STORE: (autoFixStore) => ({ autoFixStore }),
		ADD_AUTO_FIX_PM_CT: ({ customer, jobNumber, lineName, surveys, ct, pm } = {}) => ({ customer, jobNumber, lineName, surveys, ct, pm }),
		REMOVE_AUTO_FIX_PM_CT: ({ customer, jobNumber, lineName, surveys, ct, pm } = {}) => ({ customer, jobNumber, lineName, surveys, ct, pm }),
		CLEAR_AUTO_FIX_PM_CT: () => ({ }),
		SET_AUTO_FIX_IS_FIXING: (isFixing) => ({ isFixing }),
		SET_AUTO_FIX_IS_STOPPING: (isStopping) => ({ isStopping }),



		SET_JOB_LIST_TAB: (tab) => ({ tab }),
		SET_F_JOBS: (fjobs) => ({ fjobs }),
		SET_S_JOBS: (sjobs) => ({ sjobs }),



		ADD_ERROR_MESSAGES: (surveys, messages) => ({ 
			timeuuids: toTimeuuids(surveys), 
			messages: forceArray(messages) 
		}),
		REMOVE_ERROR_MESSAGES: (surveys) => ({ timeuuids: toTimeuuids(surveys) }),
		CLEAR_ERROR_MESSAGES: () => ({}),



		CLEAR: () => ({}),
	},
	{ prefix: ROOT_SLICE }
);

export { 
	addIsSyncing, 
	removeIsSyncing, 
	clearIsSyncing,
	
	addIsUnsyncing, 
	removeIsUnsyncing, 
	clearIsUnsyncing,
	
	addIsDeleting, 
	removeIsDeleting, 
	clearIsDeleting,

	addIsDeleted,
	removeIsDeleted,
	clearIsDeleted,
		
	addIsQueuedForDelete, 
	removeIsQueuedForDelete, 
	clearIsQueuedForDelete,

	addIsSelected, 
	removeIsSelected, 
	clearIsSelected,

	setAutoFixStore,
	addAutoFixPmCt,
	removeAutoFixPmCt, 
	clearAutoFixPmCt,
	setAutoFixIsFixing,
	setAutoFixIsStopping,

	setJobListTab,
	setFJobs,
	setSJobs,

	addErrorMessages,
	removeErrorMessages,
	clearErrorMessages,
	
	clear,
};
